<template>
  <v-layout
    row
    justify-center>
    <v-dialog
      v-model="isIdle"
      persistent
      max-width="290">
      <v-card>
        <v-card-title class="headline">Your session has expired</v-card-title>
        <v-card-text>You are being logged out for security reasons.</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="orange"
            @click="onIdleOk">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { TokenService } from '@/services/storage.service'

export default {
  data () {
    return {
      isIdle: false
    }
  },
  onIdle () {
    console.log('is idle now')
    this.isIdle = true
    // if (TokenService.getToken()) {
    //   clearInterval(window.refreshInterval)
    //   clearInterval(window.refreshTokenRequest)
    //   this.isIdle = true
    //   TokenService.purge()
    // }
  },
  // onActive() {
  //   console.log('im active')
  // },
  methods: {
    onIdleOk () {
      TokenService.purge()
      this.isIdle = false
      window.location.href = process.env.VUE_APP_AZURE_AD_LOGOUT_URL + '=' + window.location.origin
      // window.location.href = '/'
    }
  }
}
</script>
<style>

</style>
